import queryString from 'query-string'

export const extractCursor = (url: string | undefined | null) => {
  if (!url || url.indexOf('?') < 0) return ''
  const query = url.split('?')[1]
  const params = queryString.parse(query)
  return (params.cursor as string) || ''
}
